import { render } from "./EventsRegisterEnd.vue?vue&type=template&id=55b33be4&scoped=true&ts=true"
import script from "./EventsRegisterEnd.vue?vue&type=script&lang=ts"
export * from "./EventsRegisterEnd.vue?vue&type=script&lang=ts"

import "./EventsRegisterEnd.vue?vue&type=style&index=0&id=55b33be4&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b33be4"]])

export default __exports__